/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css } from 'aphrodite';
import { fonts, mixins } from '@blend/consumer-components';
import { ConsumerAppConfigContext } from '../../../contexts/appConfig';
import { mediaOrientations } from '../../../common/responsive';
import { useConsumerTheme } from '../../../hooks/useConsumerTheme';

export namespace ParticipantsNameTag {
  export interface Props {
    nameTags: {
      title: string;
      name: string;
    }[];
  }
}

const generateStyles = (appConfig: ConsumerAppConfigContext) => ({
  participantsNameTagWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '92%',
    backgroundColor: mixins.fade(appConfig.colors.black, 0.75),
    position: 'fixed',
    color: appConfig.colors.white,
    ...mixins.padding(8, 12),
    ...mixins.borderRadius(4),
    [mediaOrientations.portrait]: {
      bottom: 52 + 36,
    },
    [mediaOrientations.landscape]: {
      bottom: 36,
    },
  },
  nameTagWrapper: {
    ':not(:last-child)': {
      ...mixins.margin(0, 0, 12, 0),
    },
  },
  title: {
    fontSize: 8,
    textTransform: 'uppercase',
    fontWeight: fonts.weight.medium,
  },
  name: {
    fontSize: 12,
    fontWeight: fonts.weight.medium,
  },
});

export const ParticipantsNameTag: React.FC<ParticipantsNameTag.Props> = ({ nameTags }) => {
  const { styles } = useConsumerTheme(generateStyles);

  return (
    <div className={css(styles.participantsNameTagWrapper)}>
      {nameTags.map(nameTag => (
        <div className={css(styles.nameTagWrapper)} key={`nameTag-${nameTag.name}`} data-it="NameTag">
          <div className={css(styles.title)}>{nameTag.title}</div>
          <div className={css(styles.name)}>{nameTag.name}</div>
        </div>
      ))}
    </div>
  );
};
